import { Box, Card, Dialog, DialogTitle, IconButton, Typography } from '@mui/material';
import styles from './Information.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import CONSTANTS from "../../config/constants.json";


const PrayerBhajana = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    useEffect(() => {
        window.scrollTo(0, 200); // Scroll to the top of the page
        // Find the specific heading element by its ID or class name
        const prayerbhajana = document.getElementById('prayerbhajana');
        if (prayerbhajana) {
            prayerbhajana.scrollIntoView({ behavior: 'smooth' }); // Scroll to the top
        }
    }, []);


    const HandleVideoPlayer = () :void => {
        setIsOpen(true);
      }
    
      const handleClose = () :void => {
        setIsOpen(false);
      };

    const videoPlayerDialog = () => {
        return (
           <div className={styles.scrollbar}>
              <Dialog
                 open={isOpen}
                 aria-labelledby="alert-dialog-title"
                 aria-describedby="alert-dialog-description"
                 maxWidth="xl"
                 PaperProps={{
                    style: {
                       overflowY: 'unset',
                       borderTopLeftRadius: '16px',
                       borderTopRightRadius: '16px',
                    },
                 }}
              >
                 <div
                    style={{
                       backgroundColor: '#882E14',
                       height: '76px',
                       borderTopLeftRadius: '16px',
                       borderTopRightRadius: '16px',
                    }}
                 >
                    <DialogTitle sx={{ fontWeight: 700, fontSize: 36, color: 'white' }}>
                       {'Sahana Vavatu'}
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme:any) => theme.palette.grey[500],
                        }}
                        >
              <CloseIcon />
            </IconButton>
                 </div>
                 <video width="100%" height="100%" controls autoPlay muted src="./video/sahanavavtu.mov">
                </video>
              </Dialog>
           </div>
        );
}

    return (
        <>
            <div className={styles.PoojaBhajanContainer}>
                <Typography component="div" className={styles.typoGraphyHeading}>
                    Prayers/Bhajans/Slokas
                </Typography>
                <Card className={styles.cardMaincontainer}>
                    <Card className={styles.subCard}>
                        <Box sx={{ margin: '10px 10px 0px 10px', position: "relative" }}>
                            <a href="#"
                                onClick={HandleVideoPlayer}
                                rel="noopener noreferrer">
                                <img src='/images/sahana.png' />
                            </a>
                        </Box>
                        <Typography className={styles.subCaption}>Sahana Vavathu Prayer</Typography>
                    </Card>
                    <Card className={styles.subCard}>
                        <Box sx={{ margin: '10px 10px 0px 10px', position: "relative" }}>
                            <a href= { CONSTANTS.DOMAIN_URL+ "/hints/content/html/2018/om-jai-jagadish.pdf"}
                                target="_blank"
                                rel="noopener noreferrer">
                                <img src='/images/omjai.png' />
                            </a>
                        </Box>
                        <Typography className={styles.subCaption}>Om Jai Jagadish Hare</Typography>
                    </Card>
                    <Card className={styles.subCard}>
                        <Box sx={{ margin: '10px 10px 0px 10px', position: "relative" }}>
                            <a href= { CONSTANTS.DOMAIN_URL+ "/hints/content/html/2018/om-namah-shivaaya.pdf"}
                               target="_blank"
                                rel="noopener noreferrer">
                                <img src='/images/omnames.png' />
                            </a>
                        </Box>
                        <Typography className={styles.subCaption}>Om Namah Shivaaya</Typography>
                    </Card>
                </Card>
            </div >
            {videoPlayerDialog()}
        </>
    )
}
export default PrayerBhajana;
